function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 6.08301C19.2527 7.40021 20.3065 10.8249 18.5 13.9862",
  stroke: "#D1D1D1",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3225 3.82422C22.0752 5.14142 25.8386 10.0339 21.3225 16.8081",
  stroke: "#D1D1D1",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7097 1.56641C25.4624 2.88361 30.3549 10.5987 24.7097 18.5019",
  stroke: "#D1D1D1",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5484 1L5.51611 6.64516V12.2903L14.5484 17.371V1Z",
  stroke: "#D1D1D1",
  strokeWidth: 2,
  strokeLinejoin: "bevel"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.51613 6.64551H1V11.7262V12.2907H5.51613",
  stroke: "#D1D1D1",
  strokeWidth: 2,
  strokeLinejoin: "bevel"
});

function SvgOriginalAudioVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalAudioVolume);
export default __webpack_public_path__ + "static/media/originalAudioVolume.9671d6c7abdc5fefa8c49615508eb08ad8c591ce1d06ec9b9cc1b11764d534e8.svg";
export { ForwardRef as ReactComponent };